import { Component, ChangeDetectionStrategy,
  ElementRef, Inject, ViewChild, AfterViewInit } from '@angular/core';
import {
  IDynamicFormItemTooltipPattern,
  IDynamicFormItemTooltipWidget
} from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { get , merge } from 'lodash';
import { tooltipPositions } from '@ispm/shared/directives/tooltips/tooltip.directive';

@Component({
  selector: 'ispm-gentooltipcomponent',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IspmTooltipComponent implements AfterViewInit {
  hostPosition: ClientRect | DOMRect;
  tooltip: ClientRect | DOMRect;
  tooltipConfiguration: IDynamicFormItemTooltipPattern | IDynamicFormItemTooltipWidget;
  tooltipPosition: string = tooltipPositions.BOTTOM;
  tooltipStyle: { [key: string]: string; } = { };
  static readonly ARROW_OFFSET_PX = 10;
  @ViewChild('tooltipGeneric', { static: false, read: ElementRef }) private tooltipContainer;
  constructor(@Inject('tooltipElementReference') private elementReference) {
  }

  ngAfterViewInit() {
    this.getElementPosition();
    this.setCoordinates(this.tooltipPosition);
  }
  /**
   * Element Position of Host Element and Tooltip Element
   */
  getElementPosition() {
      this.hostPosition = this.elementReference.host.getBoundingClientRect();
      this.tooltip = this.tooltipContainer.nativeElement.getBoundingClientRect();
  }

  /**
   *  Calculating the position based on the tooltipPosition
   */
  setCoordinates(tooltipPosition) {
    let topPosition, leftPosition;
    switch (tooltipPosition) {
      case tooltipPositions.RIGHT:
        topPosition = this.hostPosition.top + (this.hostPosition.height - this.tooltip.height) / 2;
        leftPosition = this.hostPosition.right + IspmTooltipComponent.ARROW_OFFSET_PX;
        this.setPosition(topPosition, leftPosition);
        break;
      case tooltipPositions.BOTTOM:
        topPosition = this.hostPosition.bottom + IspmTooltipComponent.ARROW_OFFSET_PX;
        leftPosition = this.hostPosition.left + (this.hostPosition.width - this.tooltip.width) / 2;
        this.setPosition(topPosition, leftPosition);
        break;
      case tooltipPositions.LEFT:
        topPosition = this.hostPosition.top + (this.hostPosition.height - this.tooltip.height) / 2;
        leftPosition = this.hostPosition.left - this.tooltip.width - IspmTooltipComponent.ARROW_OFFSET_PX;
        this.setPosition(topPosition, leftPosition);
        break;
      case tooltipPositions.TOP:
        topPosition = this.hostPosition.top - this.tooltip.height - IspmTooltipComponent.ARROW_OFFSET_PX;
        leftPosition = this.hostPosition.left + (this.hostPosition.width - this.tooltip.width) / 2;
        this.setPosition(topPosition, leftPosition);
        break;
    }
  }
  setPosition(top, left) {
    this.tooltipStyle['top'] = `${top}px`;
    this.tooltipStyle['left'] = `${left}px`;
    this.tooltipCustomStyling();
  }
  public tooltipCustomStyling() {
    this.tooltipStyle['pointerEvents'] = get(this.tooltipConfiguration, 'clickable') ? 'all' : 'none';
    if (this.tooltipConfiguration !== undefined) {
      this.tooltipStyle = merge(this.tooltipStyle, this.tooltipConfiguration.tooltipStyle);
    }
  }
}
